import { render, staticRenderFns } from "./account.vue?vue&type=template&id=5322f134&scoped=true&"
import script from "./account.vue?vue&type=script&lang=js&"
export * from "./account.vue?vue&type=script&lang=js&"
import style0 from "./account.vue?vue&type=style&index=0&id=5322f134&prod&lang=less&scoped=true&"
import style1 from "./account.vue?vue&type=style&index=1&id=5322f134&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5322f134",
  null
  
)

export default component.exports